var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
var Paragraph = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 48px;\n  font-size: 20px;\n  line-height: 40px;\n"], ["\n  min-height: 48px;\n  font-size: 20px;\n  line-height: 40px;\n"])));
export default (function (_a) {
    var paragraph = _a.paragraph;
    return (paragraph ? (React.createElement(React.Fragment, null, paragraph.split('\n').map(function (line, idx) {
        return React.createElement(Paragraph, { key: idx },
            '\u00a0',
            line);
    }))) : null);
});
var templateObject_1;
